<script>
import BaseConfig from './_base-config.vue';
import { AUDIO_SUB_TYPES, planTypes } from '@/common/constants';

export default {
  name: 'AudioConferencingBuyNow',
  extends: BaseConfig,
  mounted() {
    this.notifyMeeting();
  },
  methods: {
    notifyMeeting() {
      this.$nextTick(() => {
        if(this.$context.type === planTypes.TOLLFREE) {
          if(this.firstSelectCategory === AUDIO_SUB_TYPES.TOLL_FREE) {
            this.$context.$emit(
              'notify-meeting',
              this.$t('billing.common.consumption_equal_to_base', [
                this.$t('billing.tollfree.audio_conferencing.title'),
                this.$context.is.edu ? this.$t('billing.planform.title.zoom_one_education') : this.$t('billing.planform.title.zoom_meeting_zoomonenew')
              ]),
            );
          } else if(this.firstSelectCategory === AUDIO_SUB_TYPES.UNLIMITED) {
            this.$context.$emit('notify-meeting', this.$t('billing.tollfree.require_equal_number_for_audio_unlimited'));
          } else {
            this.$context.$emit('notify-meeting', '');
          }
        }
      })
    },
  },
  watch: {
    firstSelectCategory(v, ov){
      if(v !== ov) {
        this.notifyMeeting();
      }
    },
  },
}
</script>
